// protocols that can be removed from url labels
var WELL_KNOWN_PROTO = ['http://', 'https://'];
// for reasonable breakpoint
var SHORTEN_STOP_CHARS = [' ', '/', '&', '?'];
// so we can find a shorten string from the end of the string
var reverseString = function reverseString() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return input.split('').reverse().join('');
};

/**
 * The returned string can be a little shorter than preferredLength
 * or in worst case it can be one character over with added '...' in the middle.
 * @param {String} url
 * @param {Number} preferredLength defaults to 50.
 */
export var shortenUrl = function shortenUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var preferredLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 50;
  if (url.length <= preferredLength) {
    return url;
  }
  var urlValue = removeWellknownProtocolFromUrl(url);
  if (urlValue.length <= preferredLength) {
    return urlValue;
  }
  var partLength = preferredLength / 2;
  var start = shortenString(urlValue, partLength);
  var end = reverseString(shortenString(reverseString(urlValue), partLength));
  return start + '...' + end;
};

/**
 * Removes http:// or https:// from the start of the input url
 * Case-insensitive
 * @see WELL_KNOWN_PROTO for protocols that are removed
 * @param {String} url
 */
var removeWellknownProtocolFromUrl = function removeWellknownProtocolFromUrl() {
  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  // this function is just to handle url in case-insensitive way
  if (!url) {
    return url;
  }
  var input = url.toLowerCase();
  var foundProto = WELL_KNOWN_PROTO.findIndex(function (proto) {
    return input.startsWith(proto);
  });
  if (foundProto === -1) {
    return url;
  }
  return url.substring(WELL_KNOWN_PROTO[foundProto].length);
};

/**
 * Shortens given string to maxLength or a bit less if it can find a reasonable
 * character to cut from.
 * @see SHORTEN_STOP_CHARS
 * @param {String} input
 * @param {Number} maxLength defaults to 25
 */
var shortenString = function shortenString() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 25;
  if (input.length < maxLength) {
    return input;
  }
  var threshold = maxLength * 0.8;
  var candidate = input.substring(0, threshold);
  var restOfInput = input.substring(threshold).split('');
  while (restOfInput.length && candidate.length < maxLength) {
    var character = restOfInput.shift();
    if (SHORTEN_STOP_CHARS.includes(character)) {
      // encountered char that is natural shorten point
      break;
    }
    candidate += character;
  }
  return candidate;
};